import styled from '@emotion/styled';

export const DatePickerWrapper = styled.div<{
  hasError?: boolean;
  hasSuccess?: boolean;
}>`
  width: 100%;
  position: relative;

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__aria-live {
    display: none;
  }

  .react-datepicker__input-container {
    width: 100%;
    position: relative;
  }

  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle::before {
    top: -1px;
    border-bottom-color: #e5e7eb;
  }

  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle::after {
    border-top: none;
    border-bottom-color: #f9fafb;
  }

  .react-datepicker__input-container input {
    background-color: #ffffff;
    border: 1px solid;
    border-color: #f0f0ef;
    border-radius: 8px;
    color: #2b2f3b;
    font-family: Gilroy, Helvetica, Arial, sans-serif;
    font-size: 1rem;
    outline: none;
    padding: 0.9375rem;
    padding-right: 30px;
    width: 100%;
    height: 54px;
    line-height: 1.5;
    box-sizing: border-box;
    transition: border-color 0.15s ease-in-out;

    &:focus {
      border: 2px solid;
      border-color: #007bff;
    }

    &::placeholder {
      color: #9ca3af;
    }

    &:disabled {
      background-color: #f9fafb;
      color: #9ca3af;
      cursor: not-allowed;
    }
  }

  /* Essential calendar popup styles */
  .react-datepicker {
    font-family: Gilroy, Helvetica, Arial, sans-serif !important;
    font-size: 0.8rem;
    font-weight: 400;
    background-color: #fff;
    color: #000;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    display: inline-block;
    position: relative;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  }

  .react-datepicker-popper {
    z-index: 1000;
  }

  .react-datepicker__header {
    text-align: center;
    background-color: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 8px 0;
    position: relative;
  }

  .react-datepicker__current-month {
    margin-top: 0;
    color: #374151;
    font-weight: 600;
    font-size: 0.944rem;
  }

  .react-datepicker__navigation {
    background: none;
    cursor: pointer;
    position: absolute;
    top: 8px;
    padding: 0;
    border: none;
    z-index: 1;
    height: 32px;
    width: 32px;
    text-indent: -999em;
    overflow: hidden;
  }

  .react-datepicker__navigation--previous {
    left: 8px;
  }

  .react-datepicker__navigation--next {
    right: 8px;
  }

  .react-datepicker__navigation-icon::before {
    border-color: #6b7280;
    border-style: solid;
    border-width: 2px 2px 0 0;
    content: '';
    display: block;
    height: 9px;
    position: absolute;
    top: 6px;
    width: 9px;
  }

  .react-datepicker__navigation-icon--next::before {
    transform: rotate(45deg);
    left: -7px;
  }

  .react-datepicker__navigation-icon--previous::before {
    transform: rotate(225deg);
    right: -7px;
  }

  .react-datepicker__month {
    margin: 0.4rem;
    text-align: center;
  }

  .react-datepicker__day-names,
  .react-datepicker__week {
    white-space: nowrap;
  }

  .react-datepicker__day-name,
  .react-datepicker__day {
    color: #374151;
    display: inline-block;
    width: 1.7rem;
    line-height: 1.7rem;
    text-align: center;
    margin: 0.166rem;
  }

  .react-datepicker__day {
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.15s ease;

    &:hover {
      background-color: #f3f4f6;
    }
  }

  .react-datepicker__day--today {
    background-color: #dbeafe;
    color: #1d4ed8;
    font-weight: bold;
  }

  .react-datepicker__day--selected {
    background-color: #3b82f6;
    color: white;

    &:hover {
      background-color: #2563eb;
    }
  }

  .react-datepicker__day--keyboard-selected {
    background-color: #e5edff;
    color: #1d4ed8;
  }

  .react-datepicker__day--disabled {
    cursor: default;
    color: #9ca3af;

    &:hover {
      background-color: transparent;
    }
  }

  /* Year dropdown styles */
  .react-datepicker__year-dropdown {
    background-color: #f9fafb;
    position: absolute;
    width: 50%;
    left: 25%;
    top: 30px;
    z-index: 1;
    text-align: center;
    border-radius: 6px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }

  .react-datepicker__year-dropdown--scrollable {
    height: 150px;
    overflow-y: scroll;
  }

  .react-datepicker__year-option {
    line-height: 20px;
    width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
    padding: 5px 0;
  }

  .react-datepicker__year-option:hover {
    background-color: #f3f4f6;
  }

  .react-datepicker__year-option--selected_year {
    background-color: #2563eb !important;
    color: white;
    font-weight: bold;
  }

  .react-datepicker__year-option--selected:hover {
    background-color: #1d4ed8; /* Even darker on hover */
  }

  .react-datepicker__year-option--selected {
    display: none !important;
  }

  .react-datepicker__year-read-view {
    border: 1px solid transparent;
    border-radius: 6px;
    position: relative;
    cursor: pointer;
    padding: 2px 4px;
  }

  .react-datepicker__year-read-view:hover {
    background-color: #f3f4f6;
  }

  .react-datepicker__year-read-view--down-arrow {
    border-color: #b3b3b3;
    border-style: solid;
    border-width: 2px 2px 0 0;
    content: '';
    display: block;
    height: 6px;
    position: absolute;
    top: 4px;
    width: 6px;
    transform: rotate(135deg);
    right: -16px;
  }
`;
